import React from "react";

export default function QRCodeErrorModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-sm rounded-lg shadow-lg p-6 text-center">
        <h2 className="text-lg font-semibold text-gray-800 mb-2">Invalid QR Code Format</h2>
        <div className="text-gray-600 mb-4 mt-4 text-center">
          <p>If the QR code is damaged, please ask the score report provider to submit a clean copy.</p>
        </div>

        <button
          onClick={onClose}
          className="mt-2 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
}
